import classNames from 'classnames';
import React, { ReactNode } from 'react';
import { ErrorBoundary } from '../ErrorBoundary';
import { TabsRole } from './const';
import classes from './styles/tabPanel.module.scss';
import { TabComponent, TabId } from './types';
import { useTabsWrapperProvider } from './Tabs';
import { getTabId, getTabPanelId } from './utils';

export type TabPanelProps = {
	id: TabId;
	dataTestId?: string;
	children: ReactNode;
	className?: string;
	keepMounted?: boolean;
};

/**
 * TabPanel - is where tab content is stored
 * Must be direct child of Tabs component
 */
export const TabPanel: TabComponent<TabPanelProps> = ({ id, keepMounted, dataTestId, className, children }) => {
	const { activeTab } = useTabsWrapperProvider();

	const selected = id === activeTab;

	const componentClasses = classNames(
		classes.panel,
		{
			[classes.panel_selected]: selected,
			[classes.panel_mountedInvisible]: keepMounted && !selected,
		},
		className,
	);

	return (
		<div
			id={getTabPanelId(id)}
			// left data-testid value exactly the same as the old tab panel had to preserve compatibility
			data-testid={dataTestId || id}
			className={componentClasses}
			role='tabpanel'
			aria-labelledby={getTabId(id)}
		>
			{(selected || keepMounted) && <ErrorBoundary>{children}</ErrorBoundary>}
		</div>
	);
};

TabPanel.tabsRole = TabsRole.TabPanel;
